import React, { lazy } from 'react';

const ACExportDetailsListing = lazy(() => import('./ACExportDetailsListing'));
const ACExportDetailsForm = lazy(() => import('./ACExportDetailsForm'));
const ACExportDetailsView = lazy(() => import('./ACExportDetailsView'));

const ROOT = '/gl-interface';
const DETAILS = `${ROOT}/ac-export-details`;

export const AcExportPaths = {
  ROOT,
  LISTING: DETAILS,
  ADD: `${DETAILS}/add`,
  VIEW: (batchNo = ':batchNo') => `${DETAILS}/${batchNo}/view` as const,
} as const;

const acExportRoutes = [
  {
    props: { exact: true, path: AcExportPaths.LISTING },
    component: <ACExportDetailsListing />,
  },
  {
    props: { exact: true, path: AcExportPaths.ADD },
    component: <ACExportDetailsForm />,
  },
  {
    props: { exact: true, path: AcExportPaths.VIEW(':batchNo') },
    component: <ACExportDetailsView />,
  },
];

export default acExportRoutes;
